import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import ProductImageComponent from '@prisjakt/ui-product-image';
import { CardContent } from '@prisjakt/ui/card';
import PositionInListComponent from '../position-in-list';

export const ProductName = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: ${layout.measurements.spacingSmall};
`;

export const ProductImage = styled(ProductImageComponent)`
  height: 140px;
`;

export const Content = styled(CardContent)`
  > :not(:last-child) {
    margin-bottom: ${layout.measurements.spacingNormal};
  }
`;

export const PositionInList = styled(PositionInListComponent)`
  position: absolute;
  top: ${layout.measurements.spacingNormal};
  left: ${layout.measurements.spacingNormal};
`;
